import GLightbox from 'glightbox';

const LanguagePopup = () => {
  const lightbox = GLightbox({
    'selector': '.language-popup-js',
  });
}

export default LanguagePopup;